// LEGACY UI: replace with FieldError from @workspace/frontend-ui.
// Don't import this in new code; legacy-ui.json tracks the remaining importers
// and only shrinks (scripts/legacy-ui-check.mjs).
import useTranslation from "@casino/legacy/client/hooks/i18n/useTranslation";
import useSite from "@casino/legacy/client/hooks/useSite";
import { cn } from "@workspace/frontend-ui";
import type { HTMLAttributes } from "react";

type Props = { message?: string } & HTMLAttributes<HTMLParagraphElement>;

const FormError: FC<Props> = ({
  message = "",
  children,
  className,
  ...htmlProps
}) => {
  const { siteConfig } = useSite();
  const formatMessage = message?.startsWith("error.")
    ? message.replace("error.", "errors.")
    : message;
  const domainTranslation = useTranslation(formatMessage).replace(
    "bitcasino.io",
    siteConfig.domain,
  );

  const content = domainTranslation || children;
  if (!content) return null;

  return (
    <p
      role="alert"
      className={cn("mt-2 inline-block text-xs text-destructive", className)}
      {...htmlProps}
    >
      {content}
    </p>
  );
};

export default FormError;
